import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const RouteTracker = () => {
  const location = useLocation();
  const prevPathRef = useRef("");

  useEffect(() => {
    sessionStorage.setItem("previousPath", prevPathRef.current);
    prevPathRef.current = location.pathname;
  }, [location]);

  return null;
};

export default RouteTracker;